import { module } from "modujs";

export default class extends module {
    constructor(m) {
        super(m);

        // Bind methods
        this.onResizeBind = this.onResize.bind(this);
        this.onScrollBind = this.onScroll.bind(this);

        // Data
        this.height = 0;
        this.scroll = 0;
        this.isPositionned = false;
    }

    /////////////////////////
    // Lifecycle
    init() {
        this.bindEvents();

        setTimeout(() => {
            this.onResize();
        }, 200)
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    /////////////////////////
    // Events
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind);
        window.addEventListener("scroll", this.onScrollBind);
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind);
        window.removeEventListener("scroll", this.onScrollBind);
    }

    /////////////////////////
    // Callbacks
    onResize() {
        this.height = this.el.offsetHeight - window.innerHeight;
    }

    onScroll() {
        this.scroll = window.scrollY;
        this.compare();
    }

    /////////////////////////
    // Methods
    compare() {
        if (this.scroll > this.height && !this.isPositionned) {
            this.isPositionned = true
            this.el.classList.add('is-positionned')
        } else if (this.scroll < this.height && this.isPositionned) {
            this.isPositionned = false
            this.el.classList.remove('is-positionned')
        }
    }
}
